const AdproRoutes = {
  getAllAdPros: "/adpro/getAdpros",
  downloadFile: "/ad/download?path=",
  updateStatus: "/admin/updateAdPro"
}

export default AdproRoutes;